import dynamic from 'next/dynamic';

import { HeroProps } from './HeroBanner.types';

export const HeroBanner = dynamic<HeroProps>(() => import('./HeroBanner'));
